var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FFF8E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2659 28.9981H10.7329C10.3756 28.9981 10.0455 28.8075 9.86688 28.4981C9.68825 28.1887 9.68825 27.8075 9.86688 27.4981L19.1329 11.4981C19.3117 11.1892 19.6415 10.999 19.9984 10.999C20.3553 10.999 20.6851 11.1892 20.8639 11.4981L30.1299 27.4981C30.3084 27.8074 30.3085 28.1883 30.1301 28.4977C29.9518 28.807 29.622 28.9977 29.2649 28.9981H29.2659ZM18.9999 23.9981V25.9981H19.9329H19.9979H20.0629H20.9979V23.9981H18.9999ZM18.9999 16.9981V21.9981H20.9999V16.9981H18.9999Z",
    fill: "#FFBF40"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityAlert);
export default __webpack_public_path__ + "static/media/activity-alert.59570406.svg";
export { ForwardRef as ReactComponent };